export const routes = {
  generic_report: (reportGroupId: string): string =>
    `/generic-report/${reportGroupId}`,
}
